/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakOutcomeType } from './StreakOutcomeType';
import {
    StreakOutcomeTypeFromJSON,
    StreakOutcomeTypeFromJSONTyped,
    StreakOutcomeTypeToJSON,
    StreakOutcomeTypeToJSONTyped,
} from './StreakOutcomeType';
import type { StreakMultiplierMode } from './StreakMultiplierMode';
import {
    StreakMultiplierModeFromJSON,
    StreakMultiplierModeFromJSONTyped,
    StreakMultiplierModeToJSON,
    StreakMultiplierModeToJSONTyped,
} from './StreakMultiplierMode';
import type { StreakMultiplierAppliesTo } from './StreakMultiplierAppliesTo';
import {
    StreakMultiplierAppliesToFromJSON,
    StreakMultiplierAppliesToFromJSONTyped,
    StreakMultiplierAppliesToToJSON,
    StreakMultiplierAppliesToToJSONTyped,
} from './StreakMultiplierAppliesTo';

/**
 * An outcome that fires when a streak milestone or window completes
 * @export
 * @interface StreakOutcome
 */
export interface StreakOutcome {
    /**
     * 
     * @type {StreakOutcomeType}
     * @memberof StreakOutcome
     */
    type: StreakOutcomeType;
    /**
     * RewardConfig to distribute (for REWARD type)
     * @type {string}
     * @memberof StreakOutcome
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {StreakMultiplierMode}
     * @memberof StreakOutcome
     */
    multiplierMode?: StreakMultiplierMode;
    /**
     * 
     * @type {StreakMultiplierAppliesTo}
     * @memberof StreakOutcome
     */
    multiplierType?: StreakMultiplierAppliesTo;
    /**
     * Multiplier value (e.g., 2.0 for 2x)
     * @type {number}
     * @memberof StreakOutcome
     */
    multiplierValue?: number;
    /**
     * Duration in hours (null = lasts until streak breaks)
     * @type {number}
     * @memberof StreakOutcome
     */
    multiplierDurationHours?: number;
    /**
     * Badge to grant (for BADGE type)
     * @type {string}
     * @memberof StreakOutcome
     */
    badgeId?: string;
    /**
     * Type of unlock (PREREQUISITE, FEATURE, TIER)
     * @type {string}
     * @memberof StreakOutcome
     */
    unlockType?: string;
    /**
     * The prerequisiteId, feature flag key, or tier name to unlock
     * @type {string}
     * @memberof StreakOutcome
     */
    unlockTargetId?: string;
    /**
     * URL for external HTTP callback (for WEBHOOK type)
     * @type {string}
     * @memberof StreakOutcome
     */
    webhookUrl?: string;
    /**
     * Template vars supported — {{userId}}, {{streakCount}}, {{userName}}
     * @type {{ [key: string]: any; }}
     * @memberof StreakOutcome
     */
    webhookPayload?: { [key: string]: any; };
    /**
     * Notification title (template vars supported)
     * @type {string}
     * @memberof StreakOutcome
     */
    notificationTitle?: string;
    /**
     * Notification body (template vars supported)
     * @type {string}
     * @memberof StreakOutcome
     */
    notificationBody?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StreakOutcome
     */
    notifyUser?: boolean;
    /**
     * Also send notification to the hub owner (hub-scoped streaks)
     * @type {boolean}
     * @memberof StreakOutcome
     */
    notifyHubOwner?: boolean;
    /**
     * Also send notification to the brand contact (brand-scoped streaks)
     * @type {boolean}
     * @memberof StreakOutcome
     */
    notifyBrand?: boolean;
    /**
     * Feed scope (HUB, PLATFORM, GAME)
     * @type {string}
     * @memberof StreakOutcome
     */
    feedScope?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakOutcome
     */
    feedScopeId?: string;
    /**
     * Highlighted events get 365-day retention
     * @type {boolean}
     * @memberof StreakOutcome
     */
    feedHighlight?: boolean;
    /**
     * Number of streak freezes to grant (for milestone-earned freezes)
     * @type {number}
     * @memberof StreakOutcome
     */
    freezesGranted?: number;
}



/**
 * Check if a given object implements the StreakOutcome interface.
 */
export function instanceOfStreakOutcome(value: object): value is StreakOutcome {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function StreakOutcomeFromJSON(json: any): StreakOutcome {
    return StreakOutcomeFromJSONTyped(json, false);
}

export function StreakOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakOutcome {
    if (json == null) {
        return json;
    }
    return {
        
        'type': StreakOutcomeTypeFromJSON(json['type']),
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'multiplierMode': json['multiplierMode'] == null ? undefined : StreakMultiplierModeFromJSON(json['multiplierMode']),
        'multiplierType': json['multiplierType'] == null ? undefined : StreakMultiplierAppliesToFromJSON(json['multiplierType']),
        'multiplierValue': json['multiplierValue'] == null ? undefined : json['multiplierValue'],
        'multiplierDurationHours': json['multiplierDurationHours'] == null ? undefined : json['multiplierDurationHours'],
        'badgeId': json['badgeId'] == null ? undefined : json['badgeId'],
        'unlockType': json['unlockType'] == null ? undefined : json['unlockType'],
        'unlockTargetId': json['unlockTargetId'] == null ? undefined : json['unlockTargetId'],
        'webhookUrl': json['webhookUrl'] == null ? undefined : json['webhookUrl'],
        'webhookPayload': json['webhookPayload'] == null ? undefined : json['webhookPayload'],
        'notificationTitle': json['notificationTitle'] == null ? undefined : json['notificationTitle'],
        'notificationBody': json['notificationBody'] == null ? undefined : json['notificationBody'],
        'notifyUser': json['notifyUser'] == null ? undefined : json['notifyUser'],
        'notifyHubOwner': json['notifyHubOwner'] == null ? undefined : json['notifyHubOwner'],
        'notifyBrand': json['notifyBrand'] == null ? undefined : json['notifyBrand'],
        'feedScope': json['feedScope'] == null ? undefined : json['feedScope'],
        'feedScopeId': json['feedScopeId'] == null ? undefined : json['feedScopeId'],
        'feedHighlight': json['feedHighlight'] == null ? undefined : json['feedHighlight'],
        'freezesGranted': json['freezesGranted'] == null ? undefined : json['freezesGranted'],
    };
}

export function StreakOutcomeToJSON(json: any): StreakOutcome {
    return StreakOutcomeToJSONTyped(json, false);
}

export function StreakOutcomeToJSONTyped(value?: StreakOutcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': StreakOutcomeTypeToJSON(value['type']),
        'rewardConfigId': value['rewardConfigId'],
        'multiplierMode': StreakMultiplierModeToJSON(value['multiplierMode']),
        'multiplierType': StreakMultiplierAppliesToToJSON(value['multiplierType']),
        'multiplierValue': value['multiplierValue'],
        'multiplierDurationHours': value['multiplierDurationHours'],
        'badgeId': value['badgeId'],
        'unlockType': value['unlockType'],
        'unlockTargetId': value['unlockTargetId'],
        'webhookUrl': value['webhookUrl'],
        'webhookPayload': value['webhookPayload'],
        'notificationTitle': value['notificationTitle'],
        'notificationBody': value['notificationBody'],
        'notifyUser': value['notifyUser'],
        'notifyHubOwner': value['notifyHubOwner'],
        'notifyBrand': value['notifyBrand'],
        'feedScope': value['feedScope'],
        'feedScopeId': value['feedScopeId'],
        'feedHighlight': value['feedHighlight'],
        'freezesGranted': value['freezesGranted'],
    };
}

